import {
  BasicProps as BaseContentProps,
  Content as BaseContent,
} from 'antd/lib/layout/layout'

export interface ContentProps extends BaseContentProps {}

export const Content = (props: ContentProps): JSX.Element => (
  <>
    <BaseContent {...props} />
  </>
)
